import { render, staticRenderFns } from "./ReportTabGroupMealsTabCustomers.vue?vue&type=template&id=5e5eb326"
import script from "./ReportTabGroupMealsTabCustomers.vue?vue&type=script&lang=js"
export * from "./ReportTabGroupMealsTabCustomers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports